// ----------------------------------------------------------------------------
// Template: Product
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import {load} from '@shopify/theme-sections';
import 'snippets/breadcrumbs/breadcrumbs';
import 'snippets/reviews/reviews';
import 'snippets/cart-confirmation/cart-confirmation';
import 'snippets/_containers/swatches/swatches';
import 'snippets/specs-table/specs-table';

import 'sections/header/header';
import 'sections/footer/footer';
import 'sections/product/product';
import 'sections/product-recommendations/product-recommendations';
import 'sections/price-spider/price-spider';

// Styles
import './_product.scss';


// -------------------------------------
// Hooks
// -------------------------------------
document.addEventListener('DOMContentLoaded', () => {
  load('*');
});

  // Optimalisation: Store the references outside the event handler:
  var $window = $(window);

  function checkWidth() {
      var windowsize = $window.width();
      if (windowsize < 680) {
            $('.carousel--featured-collection .swiper-slide').addClass('full');
        } else {
            $('.carousel--featured-collection .swiper-slide').removeClass('full');
        }
  }
  // Execute on load
  checkWidth();
  // Bind event listener
  $(window).resize(checkWidth);



